import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"
import { REDUX_STORE_DEFAULTS } from "../../store/config"
import { bookingAction } from "../../store/actions/bookingAction"
import { AppointmentData } from "../../config/bookingDataConfig"
import {
  updateAddOnServiceData,
  updateData,
  updatePriceData,
} from "../../store/actions/multipleBookingAction"
import logo from "../../asserts/boost-detailing-logo.png"

const SelectExtraService = () => {
  const dispatch = useDispatch()
  const [selectedService, setSelectedService] = useState([])
  let {
    bookingStepsLabel,
    stepNo,
    location,
    staffCategory,
    service,
    addOnService,
    multipleBookingStatus,
    otherVehicleInfo,
  } = useSelector((state) => state.bookingReducer)
  let { allAddOnService } = useSelector((state) => state.serviceReducer)

  const [addOnServiceList, setAddOnServiceList] = useState()
  const [isDesOpen, setIsDesOpen] = useState(false)
  const [isDescription, setIsDescription] = useState("")

  useEffect(() => {
    console.log(allAddOnService, "allAddOnService")

    setSelectedService(addOnService)

    if (allAddOnService) {
      setAddOnServiceList(allAddOnService)
    }

    // if (Object.keys(service).length) {
    //   // console.log("extra", service, Object.keys(service).length)
    //   // setAddOnServiceList(
    //   //   AppointmentData[location.id].staff[staffCategory.id]?.servicesList[
    //   //     service.id
    //   //   ].services[service.serviceId].addonService
    //   // )
    // }

    if (
      AppointmentData[location?.id]?.staff[staffCategory?.id]?.servicesList[
        service?.id
      ]?.services[service?.serviceId]?.addonService.length === 0
    ) {
      dispatch(
        bookingAction(REDUX_STORE_DEFAULTS.UPDATE_BOOKING_STEPS(), stepNo + 1)
      )
    }
  }, [allAddOnService])

  const handleAddon = (props, keyIndex) => {
    const addOnServiceData = {
      addOnServiceId: props._id,
      addOnServiceName: props.name,
      addOnType: keyIndex,
      addOnPrice: props.salePrice,
    }

    setSelectedService((prev) => {
      prev = prev || []
      const index = prev.findIndex((item) => item.addOnServiceId === props._id)
      if (index !== -1) {
        return prev.filter((_, indexId) => indexId !== index)
      } else {
        return [...prev, addOnServiceData]
      }
    })
  }

  useEffect(() => {
    // console.log("selectedService", selectedService)
    if (selectedService.length) {
      dispatch(
        bookingAction(
          REDUX_STORE_DEFAULTS.UPDATE_BOOKING_ADD_ON_SERVICE(),
          selectedService
        )
      )
    } else {
      dispatch(
        bookingAction(REDUX_STORE_DEFAULTS.UPDATE_BOOKING_ADD_ON_SERVICE(), [])
      )
    }
    dispatch(updateData(selectedService, 4))
    dispatch(updatePriceData(otherVehicleInfo))
  }, [selectedService])

  return (
    <>
      <h1>Select Add-On (Note: Additional Charges if: Pet Hair / Mold)</h1>
      {addOnServiceList ? (
        addOnServiceList.map((value, index) => {
          return (
            <div
              key={index + "addOn"}
              className={` p-2 mt-2 border-2 rounded flex justify-between items-center h- 20 cursor-pointer relative z-10 overflow-hidden ${
                addOnService.some((item) => item.addOnServiceId === value._id)
                  ? "bg-yellow-medium_dark bg-opacity- 35 shadow-white shadow-md"
                  : "border-yellow-light_medium"
              } `}
              onClick={() => {
                handleAddon(value, index)
              }}
            >
              <div className="flex justify-between h-full w-full">
                <div className="">
                  <img
                    src={value.imageUrl ? value.imageUrl : logo}
                    alt=""
                    className="md: w-[13rem] w- [7rem] h-[9rem] object-cover"
                  />
                </div>

                <div className="flex md:space-x-3 items-center justify-between flex-col md:flex-row md:w-full pl-10">
                  <div className="w-36 md:w-auto text-right">
                    <div className="flex items-center space-x-2">
                      <h1 className="md:text-xl">{value.name}</h1>
                      {value?.duration && (
                        <span className="text-xs text-gray-600">
                          dur. {value?.duration}
                        </span>
                      )}
                    </div>
                    <div className="text-left">
                      {JSON.stringify(
                        value?.serviceDiscription?.props.children
                      ) && (
                        <button
                          onClick={() => {
                            setIsDesOpen(true)
                            setIsDescription(value?.serviceDiscription)
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            width="20"
                            height="20"
                            viewBox="0 0 50 50"
                            strokeWidth="3"
                          >
                            <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"></path>
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="md:pr-10 h-full w-full md:w-auto flex flex-col justify-center text-right">
                    {value.salePrice < value.price ? (
                      <span>
                        <del className="font-normal text-red-600">
                          ${value.salePrice < value.price && value.price}
                        </del>
                        <span className="pl-2 font-semibold text-sm text-green-600">
                          {value?.tag}
                        </span>
                      </span>
                    ) : (
                      <></>
                    )}
                    {value.price > 0 && (
                      <span className="text-xl dec">
                        <span>
                          $
                          {value.salePrice < value.price
                            ? value.salePrice
                            : value.price}
                        </span>
                      </span>
                    )}
                  </div>
                </div>

                <div className="absolute w-[10rem] text-center top-[1.5rem] -right-[3rem] text-white bg-yellow-light rotate-45 capitalize shadow-md shadow-white">
                  <span>{value?.ribbon}</span>
                </div>
              </div>
            </div>
          )
        })
      ) : (
        <div className="flex justify-center flex-1">
          <span>loading....</span>
        </div>
      )}
      {isDesOpen && (
        <div className="fixed inset-0 flex backdrop-blur-sm justify-center items-center z-50">
          <div className="bg-white p-5 rounded shadow-lg w-11/12 md:w-1/3 min-h-[33%] relative">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => setIsDesOpen(false)}
                className="font-bold text-lg absolute right-0 top-0 bg-white rounded-xl border border-black size-7 justify-center items-center flex"
              >
                X
              </button>
            </div>
            <p>{isDescription}</p>
          </div>
        </div>
      )}
    </>
  )
}

export default SelectExtraService
